import React, { useEffect } from "react";
import { CssBaseline, ThemeProvider } from "@material-ui/core";

import theme from "./theme/theme";
import IndexScreen from "./screens";
import { getDirection, lang } from "./localization";

import "./App.css";

export default function App() {
  const direction = getDirection();

  useEffect(() => {
    document.documentElement.setAttribute("dir", direction);
    document.documentElement.setAttribute("lang", lang);
    document.body.setAttribute("dir", direction);
    document.body.setAttribute("data-language", lang);
  }, [direction]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className={`app-root app-root--${direction}`}>
        <IndexScreen />
      </div>
    </ThemeProvider>
  );
}
